import { type AxiosResponse } from 'axios';

import { BaseError } from './BaseError';

export class HttpClientError<T = any> extends BaseError {
  public readonly response?: AxiosResponse<T>;

  public readonly body: T | null;

  constructor(
    message: string,
    response?: AxiosResponse<T>,
    context?: Record<string, unknown>,
  ) {
    super(message, context);
    this.name = 'HttpClientError';
    this.response = response;
    this.body = response?.data ?? null;
  }
}
